// Desc: File utility functions 
export const getFileExtension = (filename) => filename?.split('.').pop().toUpperCase() || '';
export const GetFileNameWithoutExtension = (name) => name.slice(0, -(getFileExtension(name).length + 1));